
export const REQUEST_ADDNEWNOTE= 'REQUEST_ADDNEWNOTE';
export const ADDNEWNOTE_RECEIVED = 'ADDNEWNOTE_RECEIVED';